<template>
  <v-container
    class="px-5"
  >
    <v-row>
      <v-col
        class="text-center"
        cols="12"
      >
        <v-icon
          size="10rem"
          class="primary--text"
        >
          fa-user-edit
        </v-icon>
        <h1>{{ $t('start.header') }}</h1>
      </v-col>
      <v-col md="12"
             lg="9"
             class="mx-auto">
        <p>{{ $t('start.desc-1') }}</p>
        <p>{{ $t('start.desc-2') }}</p>
        <p>{{ $t('start.desc-3') }}</p>
        <ul>
          <li><contract-viewer text="contractTerms" classes="primary--text" /></li>
        </ul>
        
      </v-col>
      <span id="addOrder" />
      <v-expand-transition>
        <v-col
          v-if="start"
          class="text-center"
          cols="12"
        >
          <label class="input-label">
            <span class="mr-3">{{ $t('start.addOrder') }}</span>
            <v-tooltip bottom max-width="300px">
              <template v-slot:activator="{ on }">
                <v-icon color="primary" dark v-on="on">fas fa-info-circle</v-icon>
              </template>
              <span>{{ $t('start.addOrderToolTip') }}</span>
            </v-tooltip>            
          </label>
          <div class="radio-tile-group justify-center">
            <div class="input-container">
              <input
                id="yes"
                v-model="skipOrder"
                class="radio-button"
                type="radio"
                :value="false"
                @click="scroll('isIndisputable')"
              >
              <div class="radio-tile">
                <v-icon>fas fa-file-invoice</v-icon>
                <label for="yes"
                       class="radio-tile-label">{{ $t('start.addOrderNow') }}</label>
              </div>
            </div>
            <div class="input-container">
              <input
                id="no"
                v-model="skipOrder"
                class="radio-button"
                type="radio"
                :value="true"
              >
              <div class="radio-tile">
                <v-icon>far fa-clock</v-icon>
                <label for="person"
                       class="radio-tile-label">{{ $t('start.addOrderLater') }}</label>
              </div>
            </div>
          </div>
        </v-col>
      </v-expand-transition>
      <span id="isIndisputable" />
      <v-expand-transition>
        <v-col
          v-if="skipOrder !== null && !skipOrder"
          class="text-center mx-auto"
          md="12"
          lg="9"
        >
          <label class="input-label">
            <span class="mr-3">{{ $t('start.isOrderIndisputable') }}</span>
            <v-tooltip bottom max-width="300px">
              <template v-slot:activator="{ on }">
                <v-icon color="primary" dark v-on="on">fas fa-info-circle</v-icon>
              </template>
              <span>{{ $t('start.indisputableTooltip') }}</span>
            </v-tooltip>
          </label>
          <div class="radio-tile-group justify-center">
            <div class="input-container ">
              <input
                id="yes"
                v-model="indisputable"
                class="radio-button"
                type="radio"
                :value="true"
                @click="scroll('start-button')"
              >
              <div class="radio-tile">
                <v-icon>fa-thumbs-up</v-icon>
                <label for="yes"
                       class="radio-tile-label">{{ $t('common.yes') }}</label>
              </div>
            </div>
            <div class="input-container">
              <input
                id="no"
                v-model="indisputable"
                class="radio-button"
                type="radio"
                :value="false"
              >
              <div class="radio-tile">
                <v-icon>fa-thumbs-down</v-icon>
                <label for="person"
                       class="radio-tile-label">{{ $t('common.no') }}</label>
              </div>
            </div>
          </div>
          <span v-if="indisputable === false">{{ $t('start.indisputableInfo') }}</span>
        </v-col>
      </v-expand-transition>
      <v-col
        class="text-center"
        cols="12"
      >
        <v-btn v-if="!start"
               large
               tile
               class="primary"
               @click="start = true; scroll('addOrder')">
          {{ $t('start.start') }}
        </v-btn>
        <v-btn
          v-if="start"
          id="start-button"
          large
          tile
          class="primary"
          :disabled="isNavigationDisabled"
          @click="continueForward"
        >
          {{ $t('common.continue') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import ContractViewer from '../views/ContractViewer.vue'

  export default {
    data: () => ({
      scrollOptions: {
        duration: 300,
        offset: 0,
        easing: 'easeInOutCubic'
      }
    }),
    components: {
      'contract-viewer': ContractViewer
    },
    computed: {
      start: {
        get: function () {
          return this.$store.getters.start
        },
        set: function (value) {
          this.$store.commit('setStart', value)
        }
      },
      skipOrder: {
        get: function () {
          return this.$store.getters.skipOrder
        },
        set: function (value) {
          this.$store.commit('setSkipOrder', value)
        }
      },
      indisputable: {
        get: function () {
          return this.$store.getters.indisputable
        },
        set: function (value) {
          this.$store.commit('setIndisputable', value)
        }
      },
      isNavigationDisabled () {
        return this.$store.getters.isNavigationDisabled
      }
    },
    methods: {
      continueForward () {
        if (!this.skipOrder) {
          this.$router.push('order')
        } else {
          this.$router.push('basic-information')
        }
      },
      scroll (target) {
        this.$nextTick(() => {
          this.$vuetify.goTo('#' + target, this.scrollOptions)
        })
      }
    }
  }
</script>
